// extracted by mini-css-extract-plugin
export default {"textH":"TextH_textH__6Jr-Y","c1Head":"TextH_c1Head__xgPI5","shrinked":"TextH_shrinked__4sP08","c3Head":"TextH_c3Head__UgJ7+"};